import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { ToastService } from '../../../common-services/Toast/ToastService';
import { strings } from '../../../resources/strings';
import { ReportService } from '../../Reports/ReportService';
import { GetLensCertificateLabelInput } from './GetLensCertificateLabelInput';

export class GetLensCertificateLabelService extends HttpServiceBase {

  constructor(
    private report: ReportService,
    private toaster: ToastService,
    http?: any | null
  ) {
    super(http);
  }

  fileHandle = (input: GetLensCertificateLabelInput) => {
    this.http.postToDownloadFile<GetLensCertificateLabelInput>(
      `${this.baseUrlSislogApi}/v2/lens-certificate-label/file`,
      input
    ).then(result => {
      this.report.download(result, `${strings.LabelsOfLensCertification}.zpl`);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingFile);
    });
  }

  pdfHandle = (input: GetLensCertificateLabelInput) => {
    this.http.postToDownloadFile<GetLensCertificateLabelInput>(
      `${this.baseUrlSislogApi}/v2/lens-certificate-label/pdf`,
      input
    ).then(result => {
      this.report.openPdf(result);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingFile);
    });
  }
}